export default __webpack_public_path__ + "static/media/sales_two.85042d86.svg";